




















































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { MetaInfo } from "vue-meta";

@Component<Contact>({
  metaInfo(): MetaInfo {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      title: "SWISS ECO BAGS ™ | " + (this as any).$i18n.t("appbar.contact"),
      meta: [
        {
          vmid: "description",
          name: "description",
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (this as any).$i18n.t("contact.description"),
        },
      ],
    };
  },
})
export default class Contact extends Vue {}
